import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["factions", "LoaderComponent", "tooltipFormat", "showSeparator", "showStartBar", "glowSize"];
import { jsx, Fragment } from 'react/jsx-runtime';
import { Loader } from '@mantine/core';
import { forwardRef, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FactionNameToId } from '../../warzone/utils.js';
import { WarzoneProgressRound } from './WarzoneProgressRound.js';
import { useWarzoneStatus } from '../../warzone/context/warzone-status.js';
var FactionWarzoneProgressRound = forwardRef(function (_ref, ref) {
  var factions = _ref.factions,
    _ref$LoaderComponent = _ref.LoaderComponent,
    LoaderComponent = _ref$LoaderComponent === void 0 ? Loader : _ref$LoaderComponent,
    _ref$tooltipFormat = _ref.tooltipFormat,
    tooltipFormat = _ref$tooltipFormat === void 0 ? null : _ref$tooltipFormat,
    _ref$showSeparator = _ref.showSeparator,
    showSeparator = _ref$showSeparator === void 0 ? true : _ref$showSeparator,
    _ref$showStartBar = _ref.showStartBar,
    showStartBar = _ref$showStartBar === void 0 ? true : _ref$showStartBar,
    _ref$glowSize = _ref.glowSize,
    glowSize = _ref$glowSize === void 0 ? 0 : _ref$glowSize,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useWarzoneStatus = useWarzoneStatus(),
    loading = _useWarzoneStatus.loading,
    statusData = _useWarzoneStatus.statusData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var buildTooltip = useCallback(function (faction, progress, count) {
    var values = {
      faction: t("warzone.faction.".concat(faction)),
      factionShort: t("warzone.faction-short.".concat(faction)),
      progress: Math.round(progress).toLocaleString(i18n.language),
      count: count.toLocaleString(i18n.language)
    };
    if (tooltipFormat === null) {
      var text = t("warzone.tooltip.progress", _objectSpread({}, values));
      return /* @__PURE__ */jsx("div", {
        dangerouslySetInnerHTML: {
          __html: text
        }
      });
    } else if (!!tooltipFormat && !!tooltipFormat.replace) {
      return /* @__PURE__ */jsx(Fragment, {
        children: tooltipFormat.replace(/{{faction}}/, values.faction).replace(/{{factionShort}}/, values.factionShort).replace(/{{progress}}/, values.progress).replace(/{{count}}/, values.count)
      });
    }
    return void 0;
  }, [tooltipFormat, t, i18n.language]);
  var mappedFactions = useMemo(function () {
    return (factions || []).map(function (faction) {
      return {
        faction: faction,
        id: FactionNameToId(faction)
      };
    });
  }, [factions]);
  var sections = useMemo(function () {
    if (!statusData) {
      return mappedFactions.map(function (_ref2) {
        var faction = _ref2.faction;
        return {
          faction: faction,
          value: 0
        };
      });
    } else {
      return mappedFactions.map(function (_ref3) {
        var faction = _ref3.faction,
          id = _ref3.id;
        return {
          faction: faction,
          id: id,
          count: statusData.filter(function (_ref4) {
            var occupierFaction = _ref4.occupierFaction;
            return occupierFaction === id;
          }).length
        };
      }).map(function (_ref5, _i, all) {
        var faction = _ref5.faction,
          count = _ref5.count;
        var total = all.reduce(function (i, _ref6) {
          var factionCount = _ref6.count;
          return i + factionCount;
        }, 0) || 1;
        var value = count / total * 100;
        return {
          faction: faction,
          value: value,
          tooltip: buildTooltip(faction, value, count)
        };
      });
    }
  }, [statusData, mappedFactions, buildTooltip]);
  if (loading) return /* @__PURE__ */jsx(LoaderComponent, {});
  return /* @__PURE__ */jsx(WarzoneProgressRound, _objectSpread({
    ref: ref,
    sections: sections,
    showSeparator: showSeparator,
    showStartBar: showStartBar,
    glowSize: glowSize
  }, rest));
});
FactionWarzoneProgressRound.displayName = "FactionWarzoneProgressRound";
export { FactionWarzoneProgressRound };